// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"CreateRecipes_conteiner__2Yp-0","error":"CreateRecipes_error__3bVeh","ok":"CreateRecipes_ok__2cnKS"};